
import { defineComponent, type PropType } from 'vue'

/**
 * Remplacement local d'`AdnHierarchicalList` (@b2ag/design-system) : une liste dont chaque
 * élément est précédé d'un coude d'arborescence, le contenu étant rendu par slot scopé.
 */
export default defineComponent({
  name: 'PHierarchicalList',
  props: {
    items: {
      type: Array as PropType<Record<string, unknown>[]>,
      default: () => [],
    },
  },
})
